import React, { useState } from "react";
import { Loading, SecondaryButton } from "@prestosports/commons-ui";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import classNames from "classnames";
import Grid from "@material-ui/core/Grid";
import commonStyles from "../../common/styles/Common.styles";
import boxScoreStyles from "../../game-stats/styles/BoxScore.styles";
import MissingStatsContainer from "../../game-stats/containers/MissingStatsContainer";
import TeamLogo from "../../team/components/TeamLogo";
import IndividualTeamStats from "../../game-stats/components/IndividualTeamStats";
import PrintButton from "../../common/components/print/PrintButton";

const IndividualStatsContainer = ({ boxScore = {} }) => {
	const commonClasses = commonStyles();
	const classes = boxScoreStyles();

	const { awayTeamStats, homeTeamStats, homeTeam, awayTeam } = boxScore;
	const { players: awayPlayersStats } = awayTeamStats || {};
	const { players: homePlayersStats } = homeTeamStats || {};

	const [currentTeamId, setCurrentTeam] = useState(awayTeam && awayTeam.id);
	const [isLoading, setIsLoading] = useState(false);

	return !awayTeamStats && !homeTeamStats ? (
		<MissingStatsContainer />
	) : (
		<Box className={commonClasses.container}>
			{isLoading && (
				<div style={{ position: "relative" }}>
					<div style={{ position: "absolute", width: "100%" }}>
						<Loading isFetching />
					</div>
				</div>
			)}
			<Box
				className={commonClasses.headerContainer}
				display="flex"
				justifyContent="space-between"
			>
				<Grid container spacing={1}>
					<Grid
						className={currentTeamId === awayTeam.id ? classes.selectedTeam : ""}
						item
					>
						<SecondaryButton
							label={awayTeam.teamName}
							onClick={() => setCurrentTeam(awayTeam.id)}
							startIcon={<TeamLogo team={awayTeam} hideName />}
						/>
					</Grid>
					<Grid
						className={currentTeamId === homeTeam.id ? classes.selectedTeam : ""}
						item
					>
						<SecondaryButton
							label={homeTeam.teamName}
							onClick={() => setCurrentTeam(homeTeam.id)}
							startIcon={<TeamLogo team={homeTeam} hideName />}
						/>
					</Grid>
				</Grid>
				<PrintButton isLoading={isLoading} setIsLoading={setIsLoading} />
			</Box>
			<Box className={classNames(commonClasses.contentContainer, classes.content)}>
				<>
					{awayTeam.id === currentTeamId && (
						<Box px={4} pb={4}>
							<TeamLogo team={awayTeam} hideName size="large" />
							<Typography variant="h4" align="center">
								{awayTeam.teamName}
							</Typography>
							<IndividualTeamStats playerStats={awayPlayersStats} />
						</Box>
					)}
					{homeTeam.id === currentTeamId && (
						<Box px={4} pb={4}>
							<TeamLogo team={homeTeam} hideName size="large" />
							<Typography variant="h4" align="center">
								{homeTeam.teamName}
							</Typography>
							<IndividualTeamStats playerStats={homePlayersStats} />
						</Box>
					)}
				</>
			</Box>
		</Box>
	);
};

export default IndividualStatsContainer;
